{
  "dsn": "https://78da087cb2326bd6555d132490a7adbe@o4508813230211072.ingest.us.sentry.io/4510108386590720",
  "deployableEnvironments": [
    "production",
    "staging",
    "qa"
  ],
  "sendDefaultPii": true,
  "tracing": {
    "sampleRate": 0.002
  },
  "tracePropagationTargets": [
    "^https://app\\.kit\\.com",
    "^https://app\\.kitstag\\.com",
    "^https://app\\.kit-qa\\.com",
    "^https://api\\.filekitcdn\\.com",
    "^https://h\\.staging-convertkitfiles\\.com",
    "^https://h\\.qa-convertkitfiles\\.com"
  ],
  "replay": {
    "sessionSampleRate": 0.0085,
    "errorSampleRate": 0.05,
    "maskAllText": false,
    "maskAllInputs": true,
    "blockAllMedia": false
  },
  "session": {
    "autoTracking": false
  },
  "allowedHosts": [
    "app.kitstag.com",
    "app.kit-qa.com",
    "app.kit.com"
  ],
  "cdnDomains": [
    "cdn.kit.com",
    "cdn.kitstag.com",
    "cdn.kit-qa.com",
    "graph.facebook.com"
  ],
  "appDomains": [
    "kit.com",
    "kitstag.com",
    "kit-qa.com",
    "filekitcdn.com"
  ],
  "blocklistedPaths": [
    "/ui/event",
    "/healthcheck",
    "/health",
    "/ping"
  ],
  "errorFilters": {
    "invalidErrors": [
      "Object Not Found Matching Id:",
      "unhandledrejection handler received a non-error"
    ],
    "networkErrors": [
      "connection refused",
      "execution expired",
      "net::readtimeout",
      "load failed",
      "failed to fetch",
      "network error",
      "networkerror when attempting to fetch resource"
    ],
    "sdkNoise": [
      "Non-Error promise rejection captured with value:",
      "webkit-masked-url://hidden"
    ],
    "slateErrors": [
      "Cannot resolve a Slate",
      "Cannot resolve a DOM",
      "Cannot descent into slate",
      "Node.assertPath",
      "Cannot find a descendant at path",
      "Slate point points to",
      "Path doesn't match yText",
      "yOffset out of bounds"
    ]
  }
}